import { DateTime } from "luxon"

import { LocalizedStrict } from "../../../../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../../../../modules/localization/useDateTime"
import type { DeliveryOpeningLimits } from "../../helpers"

import { DeliveryMessageBox } from "./DeliveryMessageBox"

type OpeningHoursHintMessageProps = Readonly<{
    bookingStart: DateTime
    // The shop's configured window, not the picker bounds: those are narrowed to "now" for
    // today and would claim the shop opens at the current time.
    openingLimits: DeliveryOpeningLimits
}>

/**
 * Shown when the meeting starts outside the shop's delivery window. It names the meeting time
 * as well, because the window alone does not tell the user why the message concerns them.
 */
export function OpeningHoursHintMessage({ bookingStart, openingLimits }: OpeningHoursHintMessageProps) {
    const dateTimeFactory = useDateTime()

    const bookingTime = dateTimeFactory.toHourMinute(bookingStart)
    const minTime = dateTimeFactory.toHourMinute(openingLimits.minTime)
    const maxTime = dateTimeFactory.toHourMinute(openingLimits.maxTime)

    return (
        <LocalizedStrict
            id="create-order-delivery-times-dialog-delivery-time-event-start"
            vars={{ bookingTime, minTime, maxTime }}
        >
            <DeliveryMessageBox>
                Your meeting starts at {bookingTime}, but the shop owner only delivers between {minTime} and {maxTime}.
                Please pick a delivery time within that window.
            </DeliveryMessageBox>
        </LocalizedStrict>
    )
}
